import React from 'react';

import _ from 'i18n';

const SidePageHeader = ({ app, subHeader, tabContainer, organization }) => {

  return (
    <div className={`side-page-header ${tabContainer ? "absolute" : ""}`}>
      <div className="side-page-header__info">
        <p> {_(app)} </p>
        <img src="/img/icons/Arrow.svg" />
        <p className="sub-header"> {subHeader} </p>
        {organization && (
          <div className="flex">
            <img src="/img/icons/Arrow.svg" />
            <p className="sub-header"> {organization} </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SidePageHeader;


// WEBPACK FOOTER //
// ./app/components/common/SidePageHeader.js